import React from 'react';
import BreadCrumbs from '../../../components/common/breadcrumbs/BreadCrumbs';
import { useLocation } from 'react-router-dom';

const BreadcrumbsContainer = ({title = '', icon}) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const titlenames = title.split('/').filter((x) => x);

  return <BreadCrumbs pathnames={pathnames} titlenames={titlenames} icon={icon} />;
};

export default BreadcrumbsContainer;
